// Service Worker Diagnostics for Production
export async function runSWDiagnostics() {
  console.log("=== Service Worker Diagnostics ===");

  // 1. Check if service workers are supported
  if (!("serviceWorker" in navigator)) {
    console.error("❌ Service Workers not supported in this browser");
    return;
  }
  console.log("✅ Service Workers supported");

  // 2. Check current registration
  try {
    const registration = await navigator.serviceWorker.getRegistration();
    if (registration) {
      console.log("✅ Service Worker registered");
      console.log("  Scope:", registration.scope);
      console.log("  Active:", registration.active?.state);
      console.log("  Waiting:", registration.waiting?.state);
      console.log("  Installing:", registration.installing?.state);

      // 3. Check update
      console.log("🔄 Checking for updates...");
      await registration.update();
      console.log("  Update check completed");

      // 4. Check if waiting worker appeared
      if (registration.waiting) {
        console.log("⚠️ Waiting worker detected!");
        console.log("  The update notification should appear");
      } else {
        console.log("  No updates available");
      }
    } else {
      console.error("❌ No Service Worker registration found");
    }
  } catch (error) {
    console.error("❌ Error during diagnostics:", error);
  }

  // 5. Check all registrations
  try {
    const registrations = await navigator.serviceWorker.getRegistrations();
    console.log(`📋 Total registrations: ${registrations.length}`);
    registrations.forEach((reg, index) => {
      console.log(`  Registration ${index + 1}:`, reg.scope);
    });
  } catch (error) {
    console.error("❌ Error getting registrations:", error);
  }

  console.log("=== End Diagnostics ===");
}

// Make it globally available
(window as any).swDiagnostics = runSWDiagnostics;
